export default "__VITE_PUBLIC_ASSET__9fbb200e__"